import script from "./SpendingSummaryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpendingSummaryCard.vue?vue&type=script&setup=true&lang=ts"

import "./SpendingSummaryCard.vue?vue&type=style&index=0&id=4288c3a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4288c3a8"]])

export default __exports__